// import clonedeep from 'lodash.clonedeep';
import { validationSearchParams, createSortColumns } from '../lib/tools';
import { TIMELINETILE_FULLSCREEN_MODE } from '../lib/constants';
import { ActionTypes as Type } from '../actions/operatorWorks';
import * as types from '../actions/actionTypes';

const appInitialState = {
  refreshPage: false,
  lists: {
    timelines: [],
    totalNumber: 0,
    totalPages: 0,
  },
  currentPage: 1,
  operatorWorksFullscreenMode: TIMELINETILE_FULLSCREEN_MODE.main,
  searchOptions: {
    numberPerPage: 100,
    page: 1,
    sortColumns: [
      {
        column: 'recordedDate',
        order: 'D',
      },
    ],
    operatorId: null,
    recordedDateFrom: '',
    recordedDateTo: '',
    partialOperatorName: '',
  },
  searchOptionsError: {
    recordedDateFrom: false,
    recordedDateTo: false,
  },
  checkbox: {
    ids: [],
  },
};

// OperatorPage用
export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case 'SUCCESS_API_GET_OPERATOR_WORK_RECORDS': {
      const lists = action.payload || {};
      return { ...state, lists };
    }
    case 'PAGE_OPERATOR_WORKS': {
      const page = (action && action.page) || 1;
      const { searchOptions: current } = state;
      const searchOptions = { ...current, page };
      return { ...state, searchOptions };
    }
    case 'SORT_OPERATOR_WORKS': {
      const column = (action && action.sortColumn) || 'recordedDate';
      const firstSort = (column === 'workerName' && 'A') || 'D';
      const { searchOptions: initialSearchOptions, checkbox } = appInitialState;
      const { searchOptions: currentSearchOptions } = state;
      const oldSortcolumns = currentSearchOptions.sortColumns;
      const sortColumns = createSortColumns(oldSortcolumns, column, firstSort);
      const searchOptions = {
        ...currentSearchOptions,
        page: initialSearchOptions.page,
        sortColumns,
      };
      return { ...state, searchOptions, checkbox };
    }
    case 'UPDATE_OPERATOR_WORKS_SEARCH_OPTIONS': {
      const { option: params } = action;
      const optionError = validationSearchParams(params);
      const {
        searchOptions: currentSearchOptions,
        searchOptionsError: currentSearchOptionsError,
      } = state;
      const searchOptionsError = {
        ...currentSearchOptionsError,
        ...optionError,
      };
      const { checkbox } = appInitialState;
      const searchOptions = { ...currentSearchOptions, ...params, page: 1 };
      return { ...state, searchOptions, searchOptionsError, checkbox };
    }
    case types.SUCCESS_UPDATE_WROKRECORD_TAG: {
      return { ...state, checkbox: appInitialState.checkbox };
    }
    case 'RESET_OPERATOR_WORKS': {
      const { operatorId } = action;
      const { searchOptions: initialSearchOptions } = appInitialState;
      const searchOptions = { ...initialSearchOptions, operatorId };
      return { ...appInitialState, searchOptions };
    }
    case Type.SUCCESS_API_DELETE_WORK_RECORDS: {
      const checkbox = { ...appInitialState.checkbox };
      const searchOptions = { ...state.searchOptions, page: 1 };
      return { ...state, searchOptions, checkbox };
    }
    case 'CHECK_OPERATOR_WORKS_CHECKBOX': {
      const checkedHeader = action.value === 'all';
      const { lists, checkbox } = state;
      const targetIds = checkedHeader
        ? lists.timelines.map(timeline => timeline.id)
        : [Number(action.value)];
      const ids = action.checked
        ? checkbox.ids
            .concat(targetIds)
            .filter((x, i, self) => self.indexOf(x) === i)
        : checkbox.ids.filter(x => targetIds.indexOf(x) === -1);
      return { ...state, checkbox: { ids } };
    }
    case 'OPEN_DEVICE_LOCATION_MAP': {
      const operatorWorksFullscreenMode = TIMELINETILE_FULLSCREEN_MODE.map;
      return { ...state, operatorWorksFullscreenMode };
    }
    case 'CLOSE_DEVICE_LOCATION_MAP': {
      const { operatorWorksFullscreenMode } = appInitialState;
      return { ...state, operatorWorksFullscreenMode };
    }
    case Type.SUCCESS_API_DOWNLOAD_MEDIA_FILES:
    case Type.SUCCESS_API_DOWNLOAD_CHECK_RESULT: {
      return { ...state, checkbox: appInitialState.checkbox };
    }
    default:
      return state;
  }
};
